import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import {
	FormattedText,
	IconValue,
	SvgIconName,
	Typography
} from "client/Components";
import { setTrackingId } from "client/Misc/utils";
import { reactionIconMap } from "client/Features/Reactions/ReactionsCountButton/ReactionsCountButton";
import { InlineIcon } from "./InlineIcon/InlineIcon";
import { KnowledgeItemReactionNotificationDataViewModel } from "client/Api/Notifications/notifications";
import { getComputedDisplayName } from "client/Features/AddressBook/common";
import { NumberFormatter } from "client/Hooks";
import { useHubStatisticsFormatter } from "client/Features/Hub/useHubStatisticsFormatter";

export type KnowledgeItemReactionActivityProps = {
	data: KnowledgeItemReactionNotificationDataViewModel;
};

export const KnowledgeItemReactionActivity = (props: KnowledgeItemReactionActivityProps): ReactElement => {
	const { data } = props;

	const {
		title,
		firstname,
		lastname,
		reactionKind,
		otherReactionCount
	} = data;

	const statisticsFormatter: NumberFormatter = useHubStatisticsFormatter();

	const {
		computedDisplayName
	} = getComputedDisplayName({
		firstName: firstname,
		lastName: lastname
	});

	const iconValue: IconValue = reactionIconMap[reactionKind] !== undefined
		? {
			kind: "svg",
			name: reactionIconMap[reactionKind] as SvgIconName
		} : {
			kind: "font",
			name: "thumbs-up"
		};

	return (
		<span {...setTrackingId("title")}>
			<InlineIcon icon={iconValue}/>
			<FormattedText
				text={
					otherReactionCount === 0
						? localize("_XReactedOnKnowledgeArticleY")
						: localize("_MultipleXReactedOnKnowledgeArticleY")
				}
				thingsToReplace={[
					{
						what: "{{Name}}",
						filler: (
							<Typography
								weight="bold"
								trackingId="user-name"
							>
								{computedDisplayName}
							</Typography>
						)
					},
					{
						what: "{{Title}}",
						filler: (
							<Typography
								weight="bold"
								trackingId="knowledge-item-title"
							>
								{title}
							</Typography>
						)
					},
					{
						what: "{{NumberOfUsers}}",
						filler: (
							<Typography
								weight="bold"
								trackingId="number-of-users"
							>
								+{statisticsFormatter(otherReactionCount)}
							</Typography>
						)
					}
				]}
			/>
		</span>
	);
};

KnowledgeItemReactionActivity.displayName = "KnowledgeItemReactionActivity";
